/* assets/buy-the-look.js */
(function () {
  "use strict";

  const MOBILE_MEDIA = window.matchMedia("(max-width: 749px)");
  const TABLET_MEDIA = window.matchMedia("(max-width: 989px)"); // <=989px: 1 card por vez
  const isMobile = () => MOBILE_MEDIA.matches;

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function getGapPx(el) {
    if (!el) return 0;
    const cs = window.getComputedStyle(el);
    const gap = cs.gap || cs.columnGap || "0px";
    const val = parseFloat(gap);
    return Number.isFinite(val) ? val : 0;
  }

  function setTranslateX(track, px) {
    track.style.transform = "translate3d(" + (-px) + "px, 0, 0)";
  }

  function parseSectionData(sectionEl) {
    const dataEl = sectionEl.querySelector("[data-btlook-data]");
    if (!dataEl) return null;
    try {
      return JSON.parse(dataEl.textContent || "{}");
    } catch (e) {
      return null;
    }
  }

  function escapeHtml(str) {
    return String(str || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  // ===== Scroll lock ULTRA robusto + unlock “invisível” =====
  function createScrollLock() {
    let locked = false;
    let scrollY = 0;

    const body = document.body;
    const docEl = document.documentElement;

    const saved = {
      body: {},
      htmlScrollBehavior: ""
    };

    function save(prop) {
      saved.body[prop] = body.style.getPropertyValue(prop);
    }
    function restore(prop) {
      const val = saved.body[prop];
      if (val) body.style.setProperty(prop, val);
      else body.style.removeProperty(prop);
    }

    function lock() {
      if (locked) return;
      locked = true;

      scrollY = window.scrollY || window.pageYOffset || 0;

      // evita smooth durante lock/unlock
      saved.htmlScrollBehavior = docEl.style.getPropertyValue("scroll-behavior");
      docEl.style.setProperty("scroll-behavior", "auto", "important");

      ["position", "top", "left", "right", "width", "overflow"].forEach(save);

      body.style.setProperty("position", "fixed", "important");
      body.style.setProperty("top", `-${scrollY}px`, "important");
      body.style.setProperty("left", "0", "important");
      body.style.setProperty("right", "0", "important");
      body.style.setProperty("width", "100%", "important");
      body.style.setProperty("overflow", "hidden", "important");
    }

    function unlock() {
      if (!locked) return;
      locked = false;

      const top = body.style.getPropertyValue("top");
      const y = top ? Math.abs(parseInt(top, 10)) : scrollY;

      // 1) já posiciona o scroll ENQUANTO ainda está fixed
      window.scrollTo({ top: y, left: 0, behavior: "auto" });

      // 2) restaura estilos
      ["position", "top", "left", "right", "width", "overflow"].forEach(restore);

      // 3) garante novamente no próximo frame
      requestAnimationFrame(() => {
        window.scrollTo({ top: y, left: 0, behavior: "auto" });

        if (saved.htmlScrollBehavior) {
          docEl.style.setProperty("scroll-behavior", saved.htmlScrollBehavior);
        } else {
          docEl.style.removeProperty("scroll-behavior");
        }
      });
    }

    return { lock, unlock };
  }

  // ===== Drawer + carousel =====
  function initDrawer(sectionEl, data) {
    const drawer = sectionEl.querySelector("[data-btlook-drawer]");
    if (!drawer) return { open: () => {}, close: () => {} };

    const overlay = drawer.querySelector("[data-btlook-drawer-overlay]");
    const closeBtn = drawer.querySelector("[data-btlook-drawer-close]");
    const dragArea = drawer.querySelector("[data-btlook-drawer-drag]");
    const panel = drawer.querySelector(".btlook__drawer-panel");
    const titleEl = drawer.querySelector("[data-btlook-drawer-look]");
    const carousel = drawer.querySelector("[data-btlook-drawer-carousel]");
    const track = drawer.querySelector("[data-btlook-drawer-track]");

    const scrollLock = createScrollLock();

    let currentLookIndex = null;
    let isOpen = false;

    function buildItems(lookIndex) {
      if (!data || !data.looks || !data.looks[lookIndex]) return;

      const look = data.looks[lookIndex];
      if (titleEl) titleEl.textContent = look.title || "Look";

      const products = Array.isArray(look.products) ? look.products : [];

      track.innerHTML = products
        .map((p) => {
          const img = p.image
            ? `<img src="${p.image}" alt="${escapeHtml(p.title || "")}" loading="lazy">`
            : "";
          const url = p.url || "#";
          const price = p.price || "";
          const title = p.title || "";

          return `
            <a class="btlook__drawer-item" href="${url}">
              <div class="btlook__drawer-item-media">${img}</div>
              <div class="btlook__drawer-item-body">
                <div class="btlook__drawer-item-title">${escapeHtml(title)}</div>
                <div class="btlook__drawer-item-price">${escapeHtml(price)}</div>
                <div class="btlook__drawer-item-cta">Ver produto</div>
              </div>
            </a>
          `;
        })
        .join("");
    }

    function scrollToProduct(productIndex, behavior = "smooth") {
      if (!carousel || !track) return;
      const items = Array.from(track.children);
      const idx = clamp(Number(productIndex) || 0, 0, items.length - 1);
      const item = items[idx];
      if (!item) return;

      carousel.scrollTo({ left: item.offsetLeft, behavior });
    }

    function open(lookIndex, productIndex) {
      if (!data || !data.looks) return;

      drawer.classList.remove("is-closing");

      // limpa drag anterior
      panel.style.transition = "";
      panel.style.transform = "";

      if (currentLookIndex !== lookIndex) {
        buildItems(lookIndex);
        currentLookIndex = lookIndex;
      }

      if (!isOpen) {
        scrollLock.lock();
        drawer.classList.add("is-open");
        drawer.setAttribute("aria-hidden", "false");
        isOpen = true;
      }

      requestAnimationFrame(() => {
        scrollToProduct(productIndex, "auto");
        requestAnimationFrame(() => scrollToProduct(productIndex, "smooth"));
      });
    }

    function close() {
      if (!isOpen) return;

      panel.style.transition = "";
      panel.style.transform = "";

      // mantém por cima enquanto destrava (pra não ver pulo)
      drawer.classList.add("is-closing");

      requestAnimationFrame(() => {
        scrollLock.unlock();
      });

      window.setTimeout(() => {
        drawer.classList.remove("is-open");
        drawer.classList.remove("is-closing");
        drawer.setAttribute("aria-hidden", "true");
        isOpen = false;
        currentLookIndex = null;
      }, 270);
    }

    if (overlay) overlay.addEventListener("click", close);
    if (closeBtn) closeBtn.addEventListener("click", close);

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) close();
    });

    // ===== drag-to-close =====
    let dragStartY = 0;
    let dragDelta = 0;
    let dragging = false;

    function clientY(e) {
      return e.clientY || (e.touches && e.touches[0] && e.touches[0].clientY) || 0;
    }

    function onDown(e) {
      if (!isOpen) return;
      dragging = true;
      dragDelta = 0;
      dragStartY = clientY(e);
      panel.style.transition = "none";
    }

    function onMove(e) {
      if (!dragging) return;
      const y = clientY(e);
      dragDelta = Math.max(0, y - dragStartY);
      panel.style.transform = `translateY(${dragDelta}px)`;
    }

    function onUp() {
      if (!dragging) return;
      dragging = false;

      if (dragDelta > 120) {
        close();
        return;
      }

      panel.style.transition = "transform 220ms ease";
      panel.style.transform = "translateY(0)";
      setTimeout(() => {
        panel.style.transition = "";
        panel.style.transform = "";
      }, 240);
    }

    if (dragArea) {
      dragArea.addEventListener("touchstart", onDown, { passive: true });
      dragArea.addEventListener("touchmove", onMove, { passive: true });
      dragArea.addEventListener("touchend", onUp);

      dragArea.addEventListener("pointerdown", onDown);
      window.addEventListener("pointermove", onMove);
      window.addEventListener("pointerup", onUp);
    }

    return { open, close };
  }

  // ===== Desktop/Tablet product slider =====
  function initProductSlider(lookEl) {
    const sliderEl = lookEl.querySelector("[data-btlook-slider]");
    if (!sliderEl) return null;

    const track = sliderEl.querySelector("[data-btlook-track]");
    const slides = track ? Array.from(track.querySelectorAll("[data-btlook-slide]")) : [];
    if (!track || slides.length === 0) return null;

    const prevBtn = lookEl.querySelector("[data-btlook-prev]");
    const nextBtn = lookEl.querySelector("[data-btlook-next]");
    const hotspots = Array.from(lookEl.querySelectorAll("[data-btlook-hotspot]"));

    const state = { index: 0, slideW: 0, gap: 0, maxIndex: 0, perView: 2 };

    function measure() {
      state.gap = getGapPx(track);
      state.slideW = slides[0] ? slides[0].getBoundingClientRect().width : 0;

      // <=989px (tablet/desktop pequeno): 1 card por vez
      state.perView = (!isMobile() && TABLET_MEDIA.matches) ? 1 : 2;

      state.maxIndex = Math.max(0, slides.length - state.perView);
      state.index = clamp(state.index, 0, state.maxIndex);
    }

    function updateButtons() {
      if (prevBtn) prevBtn.disabled = state.index <= 0;
      if (nextBtn) nextBtn.disabled = state.index >= state.maxIndex;
    }

    function updateTransform() {
      if (isMobile()) return; // no mobile, coluna products não aparece
      const step = state.slideW + state.gap;
      setTranslateX(track, step * state.index);
      updateButtons();
    }

    function setActive(productIndex, { scrollIntoView = true } = {}) {
      const idx = clamp(Number(productIndex) || 0, 0, slides.length - 1);

      slides.forEach((s) => {
        const sIdx = Number(s.getAttribute("data-slide-index") || "0");
        s.classList.toggle("is-active", sIdx === idx);
      });

      hotspots.forEach((h) => {
        const hIdx = Number(h.getAttribute("data-product-index") || "0");
        h.classList.toggle("is-active", hIdx === idx);
      });

      if (scrollIntoView) {
        // garante que o produto ativo apareça no viewport
        state.index = clamp(idx, 0, state.maxIndex);
        updateTransform();
      }
    }

    if (prevBtn)
      prevBtn.addEventListener("click", () => {
        state.index = clamp(state.index - 1, 0, state.maxIndex);
        updateTransform();
      });

    if (nextBtn)
      nextBtn.addEventListener("click", () => {
        state.index = clamp(state.index + 1, 0, state.maxIndex);
        updateTransform();
      });

    // re-medir quando muda o breakpoint tablet
    if (TABLET_MEDIA && TABLET_MEDIA.addEventListener) {
      TABLET_MEDIA.addEventListener("change", () => {
        measure();
        updateTransform();
      });
    }

    measure();
    setActive(0, { scrollIntoView: false });
    updateTransform();

    return { measure, updateTransform, setActive };
  }

  function initLooksSlider(sectionEl, drawerApi) {
    const viewport = sectionEl.querySelector("[data-btlook-looks-viewport]");
    const track = sectionEl.querySelector("[data-btlook-looks-track]");
    const looks = track ? Array.from(track.querySelectorAll("[data-btlook-look]")) : [];
    if (!viewport || !track || looks.length === 0) return;

    const prevBtn = sectionEl.querySelector("[data-btlook-looks-prev]");
    const nextBtn = sectionEl.querySelector("[data-btlook-looks-next]");

    let current = 0;
    let viewportW = 0;

    const productSliders = new Map();
    looks.forEach((lookEl) => productSliders.set(lookEl, initProductSlider(lookEl)));

    function setActiveLook(index) {
      current = clamp(index, 0, looks.length - 1);
      looks.forEach((l, i) => l.classList.toggle("is-active", i === current));
    }

    function updateButtons() {
      if (prevBtn) prevBtn.disabled = current <= 0;
      if (nextBtn) nextBtn.disabled = current >= looks.length - 1;
    }

    function updateTransform() {
      if (isMobile()) {
        track.style.transform = "none";
        track.style.transition = "none";
        return;
      }
      setTranslateX(track, viewportW * current);
      updateButtons();
    }

    function measure() {
      viewportW = viewport.getBoundingClientRect().width || 0;

      productSliders.forEach((api) => {
        if (!api) return;
        api.measure();
        api.updateTransform();
      });

      updateTransform();
    }

    if (prevBtn)
      prevBtn.addEventListener("click", () => {
        if (isMobile()) return;
        setActiveLook(current - 1);
        updateTransform();
      });

    if (nextBtn)
      nextBtn.addEventListener("click", () => {
        if (isMobile()) return;
        setActiveLook(current + 1);
        updateTransform();
      });

    // Hotspots — mobile abre drawer | desktop/tablet ativa produto
    sectionEl.addEventListener("click", (e) => {
      const hotspot = e.target.closest && e.target.closest("[data-btlook-hotspot]");
      if (!hotspot) return;

      e.preventDefault();
      e.stopPropagation();

      const lookIndex = Number(hotspot.getAttribute("data-look-index") || "0");
      const productIndex = Number(hotspot.getAttribute("data-product-index") || "0");

      if (isMobile()) {
        drawerApi.open(lookIndex, productIndex);
        return;
      }

      const lookEl = looks[lookIndex];
      const api = lookEl ? productSliders.get(lookEl) : null;
      if (api) api.setActive(productIndex, { scrollIntoView: true });
    });

    measure();
    setActiveLook(0);
    updateTransform();

    let resizeT;
    window.addEventListener("resize", () => {
      clearTimeout(resizeT);
      resizeT = setTimeout(measure, 120);
    });
  }

  // init imediato
  document.querySelectorAll("[data-btlook-section]").forEach((sectionEl) => {
    const data = parseSectionData(sectionEl);
    const drawerApi = initDrawer(sectionEl, data);
    initLooksSlider(sectionEl, drawerApi);
  });
})();
